import { i18n } from 'i18n';

export const ROUTE_PATH = '/admin/notifications/new';
export const NOTIFICATIONS_ROUTE_PATH = '/admin/notifications';
export const TITLE = i18n._('New Notification');
